export default __webpack_public_path__ + "static/media/element_53.6bd14114.jpg";